import React from 'react';

const OrganizationFilter = ({
  organizations,
  selectedOrg,
  onOrgChange,
  theme = {},
  showStarredOnly = false,
  onStarredChange,
  hidePrivateEvents = false,
  onHidePrivateChange,
}) => {
  const defaultTheme = {
    text: 'text-gray-900',
    secondaryText: 'text-gray-600',
    background: 'bg-white',
    border: 'border-gray-300',
  };
  const currentTheme = { ...defaultTheme, ...theme };

  return (
    <div className="flex flex-col gap-3">
      {/* Org filter row */}
      <div className="flex items-center gap-2">
        <label
          htmlFor="organization-filter"
          className={`text-sm font-medium ${currentTheme.secondaryText} shrink-0 hidden sm:block`}
        >
          Organization:
        </label>
        <select
          id="organization-filter"
          value={selectedOrg}
          onChange={(e) => onOrgChange(e.target.value)}
          className={`flex-1 rounded-md shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm p-2 border ${currentTheme.background} ${currentTheme.text} ${currentTheme.border}`}
          disabled={organizations.length === 0}
          aria-label="Filter events by organization"
        >
          <option value="all">All Organizations</option>
          {organizations.map((org) => (
            <option key={org} value={org}>{org}</option>
          ))}
        </select>
        {selectedOrg !== 'all' && (
          <button
            onClick={() => onOrgChange('all')}
            className="shrink-0 p-2 rounded-lg bg-gray-200 hover:bg-gray-300 text-gray-700"
            aria-label="Clear organization filter"
          >
            <i className="fas fa-times" aria-hidden="true"></i>
          </button>
        )}
      </div>

      {/* Toggle pill buttons */}
      <div className="flex items-center gap-2 flex-wrap">
        <button
          onClick={() => onStarredChange && onStarredChange(!showStarredOnly)}
          className={`flex items-center gap-1.5 px-3 py-1.5 rounded-full text-sm font-medium transition border ${
            showStarredOnly
              ? currentTheme.favoritesActive || 'bg-red-100 text-red-700 border-red-300'
              : currentTheme.filterInactive || 'bg-gray-100 text-gray-600 border-gray-300 hover:bg-gray-200'
          }`}
          aria-pressed={showStarredOnly}
          aria-label={showStarredOnly ? 'Showing favorites only' : 'Show favorites only'}
        >
          <i className={`${showStarredOnly ? 'fas' : 'far'} fa-heart`} aria-hidden="true"></i>
          Favorites only
        </button>

        <button
          onClick={() => onHidePrivateChange && onHidePrivateChange(!hidePrivateEvents)}
          className={`flex items-center gap-1.5 px-3 py-1.5 rounded-full text-sm font-medium transition border ${
            hidePrivateEvents
              ? currentTheme.hidePrivateActive || 'bg-blue-100 text-blue-700 border-blue-300'
              : currentTheme.filterInactive || 'bg-gray-100 text-gray-600 border-gray-300 hover:bg-gray-200'
          }`}
          aria-pressed={hidePrivateEvents}
          aria-label={hidePrivateEvents ? 'Private events hidden' : 'Hide private events'}
        >
          <i className="fas fa-eye-slash" aria-hidden="true"></i>
          Hide private
        </button>
      </div>
    </div>
  );
};

export default OrganizationFilter;
